<app-gauge-chart
  [currentValue]="currentValue"
  [maxValue]="maxValue"
  [loading]="isLoading"
></app-gauge-chart>
